(() => {
  /* Fit guard: the menu can never run into the logo or icons.
     Measures where the first and last menu items actually sit against the space the menu has
     (after fonts load, on resize, and whenever the menu changes).
     Too wide: tighten spacing. Still too wide: show the menu button instead. */
  const headerBar = document.querySelector('header.header');
  const nav = headerBar && headerBar.querySelector('.header__inline-menu');
  const list = nav && nav.querySelector('.list-menu--inline');
  if (headerBar && nav && list && !headerBar.dataset.bzFit) {
    headerBar.dataset.bzFit = 'true';
    const wide = window.matchMedia('(min-width: 1100px)');
    const fits = () => {
      const items = list.children;
      if (!items.length) return true;
      const box = nav.getBoundingClientRect();
      if (box.width < 2) return true;
      const first = items[0].getBoundingClientRect();
      const last = items[items.length - 1].getBoundingClientRect();
      let total = 0;
      for (const item of items) total += item.getBoundingClientRect().width;
      return first.left >= box.left - 1 && last.right <= box.right + 1 && total <= box.width + 1;
    };
    const apply = () => {
      headerBar.classList.remove('bz-nav-tight', 'bz-nav-collapsed');
      if (!wide.matches || fits()) return;
      headerBar.classList.add('bz-nav-tight');
      if (fits()) return;
      headerBar.classList.add('bz-nav-collapsed');
    };
    let timer;
    const check = () => {
      /* Phone/tablet layouts do not use the wide-menu fit guard. Skip redundant
         resize/observer work unless an existing desktop class needs clearing. */
      if (!wide.matches && !headerBar.classList.contains('bz-nav-tight') && !headerBar.classList.contains('bz-nav-collapsed')) return;
      clearTimeout(timer);
      timer = setTimeout(apply, 16);
    };
    apply();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
    window.addEventListener('load', check);
    window.addEventListener('pageshow', check);
    window.addEventListener('resize', check, { passive: true });
    wide.addEventListener('change', check);
    if ('ResizeObserver' in window) new ResizeObserver(check).observe(headerBar);
    new MutationObserver(check).observe(list, { childList: true, subtree: true, characterData: true });
  }

  const header = document.querySelector('.section-header');
  if (!header || header.dataset.bzIdleReveal) return;
  header.dataset.bzIdleReveal = 'true';
  const desktop = window.matchMedia('(min-width: 750px)');

  /* Product pages: the header slides away while scrolling down and returns only on scroll up */
  const isProduct = /\/products\//.test(location.pathname) || !!document.querySelector('main[data-template^="product"]');
  if (isProduct) {
    let lastY = window.scrollY;
    const busy = () =>
      !!header.querySelector('details[open]') || !!document.querySelector('dialog.bz-search-dialog[open], #BzSearchDialog[open]');
    window.addEventListener(
      'scroll',
      () => {
        const y = window.scrollY;
        if (!desktop.matches) {
          header.classList.remove('bz-hdr-hide');
          lastY = y;
          return;
        }
        const dy = y - lastY;
        if (Math.abs(dy) < 6) return;
        header.classList.add('bz-hdr-anim');
        if (dy > 0 && y > 160 && !busy()) header.classList.add('bz-hdr-hide');
        else if (dy < 0 || y <= 160) header.classList.remove('bz-hdr-hide');
        lastY = y;
      },
      { passive: true }
    );
    return;
  }

  /* Other pages: the theme's own sticky header hides on scroll down and shows again only when scrolling up.
     (The old "come back when scrolling pauses" behaviour was removed on purpose.) */
})();
